export const accepted = (value) => {
    return value === 'on' || value === 'yes' || value === 1 || value === '1' || value === true;
};
